import React, { useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles"

import { useHistory } from 'react-router';
import { toast } from "react-toastify";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FilledInput from '@material-ui/core/FilledInput';
import { register, confirmEmail } from "../functions/auth"

const useStyles = makeStyles((theme) => ({


    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "1100px",

    },
    wrapper: {
        width: "600px",
        "@media(max-width:770px)": {
            width: "90%",
            // overflow: "hidden"
        }

    },
    write: {
        marginTop: "25px",
        color: "#666",
        fontSize: "16px",
        fontWeight: "400",
        //fontFamily: ""
    },

    password: {
        width: "100%",
        height: "59px",
        border: "0",
        backgorundColor: "#fff",
        borderRadius: "3px",
        color: theme.palette.primary.main,
        fontSize: "15px",
        fontWeight: "400",
        boxShadow: "0 10px 10px rbg(225 225 225)",
        margin: "15px 0px",
        "&:focus": {
            outline: "2px solid",
        },
    },
    formcontrol: {

        margin: "15px 0px",

        // "& label": {
        //     backgroundColor: "red"
        // },




        // "& input": {

        //     backgroundColor: "white",
        //     lineHeight: "3",


        // },

        // "& div": {

        //     backgroundColor: "white",
        //     lineHeight: "3",


        // }


    },

    // visible: {

    //     display: "flex",
    //     // flexDirection: "column",
    //     alignItems: "center",
    //     //justifyContent: "center"
    //     // width: "101%"


    // },

    // visibleIcon: {

    //     backgroundColor: "#fff",
    //     borderRadius: "0 3px 3px 0",
    //     height: "59px",
    //     padding: "1px",


    // },

    gender: {
        width: "117px",
        height: "59px",
        border: "0",
        backgroundColor: "#fff",
        borderRadius: "3px",
        fontSize: "16px",
        boxShadow: "0 10px 10px rbg(225 225 225)",
        textAlign: "center",
        margin: "5px",
    },

    genderSelect: {
        width: "117px",
        height: "59px",
        border: "0",
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
        borderRadius: "3px",
        fontSize: "16px",
        boxShadow: "0 10px 10px rbg(225 225 225)",
        textAlign: "center",
        margin: "5px",
    },

    select: {

        width: "235px",
        height: "59px",
        border: "0",
        borderRadius: "3px",
        color: "#000",
        fontSize: "16px",
        boxShadow: "0 10px 10px rbg(225 225 225)",
        outline: "none",
        textAlign: "center",
        "&::-webkit-scrollbar": {
            display: "none",
            overflow: "hidden"
        }

    },


    button: {

        width: "100%",
        border: "0",
        borderRadius: "6px",
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
        fontSize: "30px",
        fontWeight: "500",
        textAlign: "center",
        height: "82px",
        margin: "20px 0",
        float: "center",

        "&:hover": {
            cursor: "pointer",
            backgroundColor: theme.palette.primary.light,
        }

    },


}))

const Register = () => {

    const [email, setEmail] = useState("");
    const [userID, setUserID] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [name, setName] = useState("");
    const [visible, setVisible] = useState(false);
    const [gender, setGender] = useState(0);
    const [yearBirth, setYearBirth] = useState(201);

    const history = useHistory();

    useEffect(() => {
        if (!window.localStorage.getItem("emailForSignIn")) {
            toast.warning("같은 브라우저에서 이메일 인증을 완료해주세요.");
            //    history.push("/signup");
            return
        }
        setEmail(window.localStorage.getItem("emailForSignIn"))
        setUserID(window.localStorage.getItem("emailForSignIn"))

        return () => {
            window.localStorage.removeItem("emailForSignIn")
        }
    }, [])


    const style = useStyles();



    const onPassword = (e) => {

        setPassword(e.target.value)

    }

    const onConfirmPassword = (e) => {

        setConfirmPassword(e.target.value)

    }

    const onName = (e) => {

        setName(e.target.value)

    }

    const onGender = () => {
        setGender(gender === 0 ? 1 : 0)

    }

    const onVisible = () => {
        setVisible(!visible);

    }

    const onYearBirth = (e) => {
        setYearBirth(e.target.value)
        // console.log(e.target.value)
    }

    const year = [];

    for (var i = 0; i < 50; i++) {
        year.push(2021 - i)
    }

    const Option = year.map((item, index) => { return <option key={index} value={item} >{item}</option> })

    const onSubmit = (e) => {
        e.preventDefault();

        if (password.length < 6) {
            toast.warning("비밀번호는 6자 이상이어야 합니다.")
            return
        }

        if (password !== confirmPassword) {
            toast.error("비밀번호가 일치하지 않습니다.");
            return
        }

        if (name.length < 2) {
            toast.warning("이름은 2자 이상이어야 합니다.")
            return
        }

        register({
            userID,
            email,
            userPassword: password,
            name,
            gender,
            yearBirth

        }).then(res => {
            //  console.log(res)
            if (res.type === true) {

                confirmEmail(email).then(result => {
                    if (result.message === 'email confirmed') {
                        window.localStorage.setItem(`${process.env.REACT_APP_TOKEN_KEY}`, res.token);
                        toast.success("회원가입이 완료되었습니다.");
                        history.push("/")
                        return;
                    }
                }
                ).catch(err => {
                    console.log(err)
                })



            } else {

                toast.error(res.message)

            }
        }).catch(err => {
            console.log(err)
            toast.error("서버와의 연결이 원활하지 않습니다.")
        })





        //  history.push("/")

    }


    return (
        <div className={style.container}>
            <div className={style.wrapper}>
                <h1>SurBay 회원가입</h1>
                <br />
                <h2>비밀번호 설정</h2>
                <div className={style.write}>6자 이상의 영문/숫자 조합 (대/소문자 구분)으로 설정해주세요.</div>
                <div>
                    <FormControl fullWidth className={style.formcontrol}>
                        <FilledInput
                            style={{ backgroundColor: "white" }}
                            id="standard-adornment-password"
                            type={visible ? 'text' : 'password'}
                            value={password}
                            onChange={onPassword}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={onVisible}
                                        onMouseDown={onVisible}
                                    >
                                        {visible ? <Visibility color="primary" /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        <InputLabel htmlFor="standard-adornment-password" >비밀번호</InputLabel>
                    </FormControl>
                    <FormControl fullWidth className={style.formcontrol}>
                        <FilledInput
                            style={{ backgroundColor: "white" }}
                            type="password"
                            id="standard-adornment-checkpassword"
                            onChange={onConfirmPassword}
                        />
                        <InputLabel htmlFor="standard-adornment-checkpassword" >비밀번호 확인</InputLabel>
                    </FormControl>
                    <h2>닉네임 설정</h2>
                    <FormControl fullWidth className={style.formcontrol}>
                        <FilledInput
                            style={{ backgroundColor: "white" }}
                            type="text"
                            id="standard-adornment-text"
                            onChange={onName}
                        />
                        <InputLabel htmlFor="standard-adornment-text" >닉네임</InputLabel>
                    </FormControl>
                    <br />
                    <h2>성별</h2>
                    <button onClick={onGender} className={gender === 0 ? style.genderSelect : style.gender}>남자</button>
                    <button onClick={onGender} className={gender === 1 ? style.genderSelect : style.gender}>여자</button>
                    <br />
                    <h2>출생연도</h2>
                    <select className={style.select} onChange={onYearBirth}>
                        {Option}
                    </select>
                    <button className={style.button} onClick={onSubmit}>완 료</button>
                </div>
            </div>
        </div>
    );
};

export default Register;